











import { Component, Vue } from "vue-property-decorator";

const NumberCardProps = Vue.extend({
  props: {
    numberValue: String,
  },
});

@Component({
  name: "NumberCard",
})
export default class NumberCard extends NumberCardProps {}
